import React from 'react';

const Utah = () => (
  <svg
    width="75"
    height="95"
    viewBox="0 0 75 95"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.129 0.923828C27.2029 2.83895 38.7417 5.29622 51.4773 6.55654C50.8929 12.6258 50.0763 18.4697 48.9147 23.9616C57.8697 24.5601 65.6561 26.3344 74.5126 27.0314C71.3657 49.1469 68.972 72.0086 65.811 94.1029C43.1206 91.702 21.8453 87.8999 0.281372 84.3724C5.29395 56.6243 10.391 28.9606 15.129 0.923828Z"
      fill="#FC374D"
    />
  </svg>
);

export default Utah;
